<template>
  <div class="container">
    <Card>
      <template slot="header">
        <h4>درخواست دمو آنلاین</h4>
        <hr />
      </template>
      <template slot="content">
        <BnpGrid :key="bnpgridkey" Selectable :Sortable="true" :IsReport="true" :ListCommaReport="[]" :HeaderReport="''" :action="true" :propsRows="rows" :propsColumn="Column" :NoRowNum="false">
          <template slot="dateTimeInsert" slot-scope="props">
            <span> {{ props.props.dateTimeInsert.substring(0, 10) }}</span>
          </template>
          <template slot="isSeen" slot-scope="props">
            <input @change="saveChanges(props.props)" type="checkbox" v-model="props.props.isSeen" class="" />
          </template>
          <template slot="isCalled" slot-scope="props">
            <input @change="saveChanges(props.props)" type="checkbox" v-model="props.props.isCalled" class="" />
          </template>
          <template slot="lastComment" slot-scope="props">
            <textarea rows="2" cols="30" v-model="props.props.lastComment" class="form-control" style="font-size: small" />
          </template>
          <template slot="action-slot" slot-scope="props"> <button @click="saveChanges(props.props)" class="btn btn-success">ثبت تغییرات</button> </template>
        </BnpGrid>
      </template>
    </Card>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card, BnpGrid },
  data() {
    return {
      bnpgridkey: 0,
      Column: [
        { name: 'phoneNum', label: 'شماره تماس', visibility: true },
        { name: 'dateTimeInsert', label: 'زمان ثبت', visibility: true },
        { name: 'lastComment', label: 'آخرین وضعیت', visibility: true },
        { name: 'isSeen', label: ' وضعیت مشاهده ', visibility: true },
        { name: 'isCalled', label: 'تماس گرفته شد', visibility: true },
      ],
      rows: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      var DataAxios = { Action: 'DemoRequest', Method: 'GET' }
      this.$PostData(DataAxios).then((result) => {
        
        this.rows = result.sort().reverse();
        this.bnpgridkey++
      })
    },
    saveChanges(x) {
      var DataAxios = { Action: 'DemoRequest/Edit', Method: 'POST', ArryfildValue: x }
      this.$PostData(DataAxios).then((result) => {
        this.getData()
        if (result.status) {
          this.$toasted.success(result.msg, { duration: 3000 })
        } else this.$toasted.error(result.msg, { duration: 3000 })
      })
    },
  },
}
</script>
